var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.01786 0.414609C3.13839 0.1605 3.38616 0 3.65625 0H6.34375C6.61384 0 6.86161 0.1605 6.98214 0.414609L7.14286 0.75H9.28571C9.6808 0.75 10 1.08586 10 1.5C10 1.91414 9.6808 2.25 9.28571 2.25H0.714286C0.319866 2.25 0 1.91414 0 1.5C0 1.08586 0.319866 0.75 0.714286 0.75H2.85714L3.01786 0.414609ZM0.694196 3H9.28571V10.5C9.28571 11.3273 8.64509 12 7.85714 12H2.12277C1.35379 12 0.694196 11.3273 0.694196 10.5V3ZM2.47991 4.875V10.125C2.47991 10.3313 2.66071 10.5 2.83705 10.5C3.05357 10.5 3.1942 10.3313 3.1942 10.125V4.875C3.1942 4.66875 3.05357 4.5 2.83705 4.5C2.66071 4.5 2.47991 4.66875 2.47991 4.875ZM4.62277 4.875V10.125C4.62277 10.3313 4.80357 10.5 4.97991 10.5C5.19643 10.5 5.35714 10.3313 5.35714 10.125V4.875C5.35714 4.66875 5.19643 4.5 4.97991 4.5C4.80357 4.5 4.62277 4.66875 4.62277 4.875ZM6.78571 4.875V10.125C6.78571 10.3313 6.94643 10.5 7.14286 10.5C7.33929 10.5 7.5 10.3313 7.5 10.125V4.875C7.5 4.66875 7.33929 4.5 7.14286 4.5C6.94643 4.5 6.78571 4.66875 6.78571 4.875Z",
    fill: "#36505E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.8a400498ca242f9e867e7bfbe073a5d2.svg";
export { ForwardRef as ReactComponent };